export const row = {
    display: 'grid',
    gap: 2.5,
    mt: 2.5,
};

export const topRow = {
    ...row,
    gridTemplateColumns: { xs: '1fr', lg: '1fr 2fr' },
};

// TODO: restore gridTemplateColumns: { xs: '1fr', lg: '2fr 1fr' } when KeyInsightDetails is re-enabled
export const middleRow = {
    ...row,
    gridTemplateColumns: '1fr',
};

export const recommendedRow = {
    mt: 2.5,
};

export const header = {
    mb: 4,
};

export const eyebrow = {
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '2.16px',
    color: 'var(--ecal-lightblue)',
    mb: 0.5,
};

export const heading = {
    fontWeight: 600,
    color: 'var(--ecal-white)',
    fontSize: '36px',
};

export const headingGradient = {
    background: 'linear-gradient(90deg, #00D7FF, #0078FF)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
};

export const subheading = {
    color: 'var(--ecal-lightgrey)',
    mt: 1,
    fontSize: '16px',
};
